import axios from 'axios'
import { baseUrl } from '../constants'


const URL = baseUrl + "/api/qASessions"
 

//for sending the token
const config = (token) => { return { 
  withCredentials: true,
  headers: { Authorization: `Bearer ${token}`, }, 
} }


const createQASession = async (data, token) => {
    const response = await axios.post(URL+"/createQASession", data, config(token))
    return response.data
}

const endQASession = async (data, token) => {
    const response = await axios.post(URL+"/endQASession", data, config(token))
    return response.data
}

const getQASessions = async (data, token) => {
    const response = await axios.post(URL+"/getSessions", data, config(token))
    return response.data
}

const getQASession = async (data, token) => {
    const response = await axios.post(URL+"/getQASession", data, config(token))
    return response.data
}

const getQuestions = async (data, token) => {
    const response = await axios.post(URL+"/getQuestions", data, config(token))
    return response.data
}
 
 const addQuestion = async (data, token) => {
    const response = await axios.post(URL+"/addQuestion", data, config(token))
    return response.data
}

 const upvoteQuestion = async (data, token) => {
    const response = await axios.post(URL+"/upvoteQuestion", data, config(token))
    return response.data
}

 const updateQuestionStatus = async (data, token) => {
    const response = await axios.post(URL+"/updateQuestionStatus", data, config(token))
    return response.data
}


const qaSessionService = {
    updateQuestionStatus, upvoteQuestion, createQASession, getQASessions, getQuestions, getQASession, addQuestion, endQASession
}



export default qaSessionService